<script setup>
import {defineEmits, defineProps, onMounted, ref} from "vue";
import axiosApi from "@/utils/axiosApi";
import {ElMessage} from "element-plus";
import store from "@/store";

const prop = defineProps(['showLogin', 'account'])
const emit = defineEmits(['login'])
const show = ref(false)
const sendSms = ref(false)
let timer = ref(0)
let times = null
onMounted(() => {
  show.value = prop.showLogin
})
const loginData = ref({
  account: "",
  password: "",
  type: "xm_air",
  login_type: 2,
  sms_text: null
})
const form = ref()
const rule = ref({
  account: [
    {required: true, message: "请输入白鹭会员手机号"},
    {
      validator: (rule, value, call) => {
        if (!/^1[3-9]\d{9}$/.test(value)) {
          call(new Error("请输入正确的手机号"))
        }
        call()
      }
    }
  ],
  password: [{required: true, message: "请输入短信验证码"}]
})
const sendSmsFn = refs => {
  clearTimeout(times)
  refs.validateField('account', err => {
    // alert(err)
    sendSms.value = err
    if (err) {
      new axiosApi({
        encode: 'site',
        method: 'user/xm_code',
        body: {mobile: loginData.value.account}
      }).send(res => {
        sendSms.value = false
        if (res.message.code !== "000") {
          return ElMessage.error(res.message.content)
        }
        loginData.value.sms_text = res.data.trace_credential
        timer.value = 60
        dis()
      }, () => sendSms.value = false)
    }
  })
}
const dis = () => {
  if (timer.value < 1) {
    clearTimeout(times)
    return
  }
  times = setTimeout(() => {
    timer.value--
    dis()
  }, 1000)
}
const login = refs => {
  refs.validate(err => {
    sendSms.value = err
    if (err) {
      new axiosApi({
        encode: 'site',
        method: 'user/login',
        body: loginData.value
      }).send((res) => {
        //subs.value = false
        //获取会员信息
        if (res.message.code !== "000") {
          return ElMessage.error(res.message.content)
        }
        new axiosApi({
          encode: 'site',
          method: 'user/xm_user_info',
          body: {
            access_token: res.data.access_token, user_id: res.data.user_id
          }
        }).send((r) => {
          if (r.message.code !== "000") {
            return ElMessage.error(r.message.content)
          }
          sendSms.value = false
          r.data.access_token = res.data.access_token
          r.data.user_id = res.data.user_id
          store.dispatch("setAccounts", r.data)
          emit("login")
        }, () => sendSms.value = false)
      }, () => sendSms.value = false)
    }
  })
}
</script>

<template>
  <el-drawer v-model="show" destroy-on-close direction="btt" class="xm-login" size="360" :show-close="false"
             @closed="emit('login')">
    <template #header>
      <div class="xm-login-header">
        <h3 class="titles">
          <el-text type="primary">白鹭会员登录</el-text>
        </h3>
        <el-text type="info">支持厦门航空、河北航空、江西航空</el-text>
      </div>
    </template>
    <el-form class="xm-login-box" size="large" ref="form" :rules="rule" :model="loginData">
      <el-form-item prop="account">
        <div class="xm-login-input">
          <el-input v-model="loginData.account" placeholder="请输入白鹭会员手机号"/>
          <el-button link type="warning" size="large" @click="sendSmsFn(form)" :loading="sendSms">
            {{ timer > 0 ? `${timer > 9 ? timer : `0${timer}`}秒` : '获取验证码' }}
          </el-button>
        </div>
      </el-form-item>
      <el-form-item prop="password">
        <div class="xm-login-input">
          <el-input v-model="loginData.password" placeholder="请输入短信验证码"/>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button round type="primary" :loading="sendSms" @click="login(form)">登录</el-button>
      </el-form-item>
    </el-form>
  </el-drawer>
</template>

<style lang="less">
.xm-login {
  border-radius: 30px 30px 0 0 !important;

  .xm-login-header {
    text-align: center;
    line-height: 1.45;
    border-bottom: 1px solid var(--el-color-primary);
    padding-bottom: 15px;

    .titles .el-text {
      font-size: 1.45rem;
    }
  }

  .xm-login-box {
    width: 85%;
    margin: -15px auto 0;
    text-align: center;

    .xm-login-input {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;

      .el-input {
        width: 70%;
        flex-basis: 70%;
        margin-right: 15px;
        --el-input-placeholder-color: var(--el-color-primary);
        line-height: 50px;

        .el-input__wrapper {
          box-shadow: none;
          border-bottom: 1px solid var(--el-color-primary);
          border-radius: 0;
        }

        input {
          width: 100%;
          line-height: 50px;
        }
      }
    }

    .el-button--primary {
      width: 80%;
      margin: auto;
    }
  }
}
</style>
